import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-foreground-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-fire-fill text-background-50 text-base"></i>
              </div>
              <span className="font-heading font-bold text-lg text-background-50">
                黑料入口
              </span>
            </div>
            <p className="text-sm text-foreground-300 leading-relaxed">
              致力于为用户提供最新、最全的娱乐资讯和热点吃瓜内容。
              每日更新，不错过任何一个热门事件。
            </p>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              内容分类
            </h4>
            <ul className="space-y-2.5">
              {categories.map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              快速链接
            </h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#faq" className="text-sm text-foreground-300 hover:text-primary-400 transition-colors cursor-pointer">
                  常见问题
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">
              联系我们
            </h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-mail-line text-primary-400"></i>
                <span>tips@heiliaorukou.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-shield-check-line text-primary-400"></i>
                <span>保护投稿人隐私</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-foreground-300">
                <i className="ri-time-line text-primary-400"></i>
                <span>每日 24 小时更新</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-foreground-800 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-400">
            &copy; {new Date().getFullYear()} 黑料入口 - 版权所有 | 本站内容仅供娱乐参考
          </p>
          <div className="flex items-center gap-4">
            <span className="text-xs text-foreground-400">黑料入口最新地址</span>
            <span className="text-xs text-foreground-400">吃瓜黑料入口</span>
            <span className="text-xs text-foreground-400">黑料吃瓜在线</span>
          </div>
        </div>
      </div>
    </footer>
  );
}